import { motion } from "framer-motion";
function AnimatedBg() {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.1,
        type: "spring",
        stiffness: 100,
        staggerChildren: 0.1,
      },
    },
  };

  const itemLeft = {
    hidden: { x: "-100vw" },
    show: {
      x: 0,
      transition: {
        duration: 0.1,
        type: "spring",
        stiffness: 100,
      },
    },
  };
  const itemRight = {
    hidden: { x: "100vw" },
    show: {
      x: 0,
      transition: {
        duration: 0.1,
        type: "spring",
        stiffness: 100,
      },
    },
  };
  return (
    <div className="hero-svg absolute w-full top-0 left-0 pointer-events-none select-none">
      <motion.svg
        variants={container}
        initial="hidden"
        animate="show"
        className=" w-full h-auto"
        width="1728"
        height="675"
        viewBox="0 0 1728 675"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.rect
          variants={itemLeft}
          y="617"
          width="355"
          height="58"
          fill="#00FFC2"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemLeft}
          y="494"
          width="112"
          height="58"
          fill="#B8BFD4"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemLeft}
          x="48"
          width="190"
          height="58"
          fill="#00FFC2"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemLeft}
          y="142"
          width="172"
          height="58"
          fill="#B8BFD4"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemLeft}
          y="373"
          width="251"
          height="58"
          fill="#00FFC2"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemLeft}
          x="394"
          y="617"
          width="159"
          height="58"
          fill="#B8BFD4"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemRight}
          x="1513"
          y="552"
          width="215"
          height="58"
          fill="#00FFC2"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemRight}
          x="1182"
          y="552"
          width="295"
          height="58"
          fill="#B8BFD4"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemRight}
          x="1433"
          y="431"
          width="295"
          height="58"
          fill="#B8BFD4"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemRight}
          x="1391"
          y="71"
          width="337"
          height="58"
          fill="#B8BFD4"
          fill-opacity="0.25"
        />
        <motion.rect
          variants={itemRight}
          x="1657"
          y="251"
          width="71"
          height="58"
          fill="#00FFC2"
          fill-opacity="0.25"
        />
      </motion.svg>
    </div>
  );
}

export default AnimatedBg;
